import React from 'react';
import useAuth from '../../hooks/useAuth';
import useBot from '../../hooks/useBot';
import AdminOverview from './AdminOverview';
import TenantOverview from './TenantOverview';
import SalesDashboard from './SalesDashboard';

const Overview = () => {
  const { user } = useAuth();
  const { isSalesBot } = useBot();
  const isAdmin = user?.role === 'admin' || user?.type === 'admin';

  if (isAdmin) return <AdminOverview />;
  if (isSalesBot) return <SalesDashboard />;
  return <TenantOverview />;
};

export default Overview;